import React from "react";

import "./VendorRequest.css";
import Sidebar from "../../Sidebar";
import DeshBoardFooter from "../../DeshBoardFooter";
import DeshbordBreadcrumb from "../../Breadcrumb/DeshbordBreadcrumb";
import VendorRequestForm from "./VendorRequestForm";
import SuccessAccept from "./SuccessAccept";
import { VendorResponseData } from "../../../FetchAPI";
import { useAuth } from "../../../../Store/AuthContext";
import { Helmet } from "react-helmet";

export default function VendorRequest() {
  const { RendomTokenfetch } = useAuth();
  const [responseStatus, responsevendordata] =
    VendorResponseData(RendomTokenfetch);

  function showFormStatusResult(responseStatus, responsevendordata) {
    let ShowStatusres = "";
    if (responseStatus !== "0") {
      ShowStatusres = (
        <>
          <SuccessAccept responsevendordata={responsevendordata} />
        </>
      );
    } else {
      ShowStatusres = "";
    }
    return ShowStatusres;
  }
  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow"></meta>
      </Helmet>
      <div className="page-wrapper dashboard mm-page mm-slideout" id="mm-0">
        <Sidebar />
        <DeshbordBreadcrumb page1={[{ name: "Send Vendor Request" }]} />
        <section className="user-dashboard vendorRequestsec">
          <div className="dashboard-outer">
            {/* <SuccessAccept responsevendordata={responsevendordata} />; */}
            {showFormStatusResult(responseStatus, responsevendordata)}

            {responseStatus !== "0" ? (
              ""
            ) : (
              <VendorRequestForm
                RendomTokenfetch={RendomTokenfetch}
                responseStatus={responseStatus}
              />
            )}
          </div>
        </section>
        <div className="deshboard_footer">
          <DeshBoardFooter />{" "}
        </div>
      </div>
    </>
  );
}
